import { Component, effect, inject } from '@angular/core';
import { OrderBaseComponent } from '../order-base.component';
import { CartStateService } from '../../../common/store/state/order/orderv2/workflows/order-cart/order-cart.state.service';

@Component({
  selector: 'app-order-cart',
  standalone: false,
  templateUrl: './order-cart.component.html',
  styleUrl: './order-cart.component.scss'
})
export class OrderCartComponent extends OrderBaseComponent {
  cartStateService = inject(CartStateService);
  cartModel = this.cartStateService.cart;
  constructor() {
    super()
    effect(() => {
      this.cartModel()
    });
  }
}
